import { Expose } from 'class-transformer';
import { Model } from '../../shared-features/models/model';

export class BankInfo extends Model {
  @Expose() IBAN: string;
  @Expose() bankName: string;
}
